import { Handle, Position } from "reactflow";

const AddButtonNode = ({ data }: any) => {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #ccc",
        padding: "6px 14px",
        borderRadius: "4px",
        cursor: "pointer",
        fontWeight: "bold",
        fontSize: "20px",
        color: "rgb(228, 0, 43)",
      }}
      onClick={data.onClick}
    >
      {data.label || "+"}
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: "#555" }}
      />
    </div>
  );
};

export default AddButtonNode;
